import styled from 'styled-components';

export const ContactContainer = styled.div`
  height: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #262626;

  @media screen and (max-width: 768px) {
    height: 1100px;
  }

  @media screen and (max-width: 480px) {
    height: 2000px;
  }
`;

export const ContactWrapper = styled.div`
margin-left:150px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 16px;


  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    margin-right: 35%;
    
  }
`;

export const ContactCard = styled.div`

background-color:#101522;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 500px;
  width:800px;
  padding: 10px;
  height:500px;
  
   @media (max-width: 480px) {
    /* Apply styles for screens with a maximum width of 480px (typical phone portrait) */
    max-width: 300px;


`;

export const ContactIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;

export const ContactH1 = styled.h1`
  font-size: 2.5rem;
  color:#fff;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
 
`;

export const ContactH2 = styled.h2`
  font-size: 2rem;
  color:#fff;
  margin-bottom: 10px;
  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    color: #01bf71
  }
`;

export const ContactP1 = styled.p`
  font-size: 1.5rem;
  text-align: left;
  margin-bottom: 10px;
  color: #fff;
  bottom-padding: 2
`;

export const ContactP2 = styled.p`
max-width: 520px;
  font-size: 1rem;
  text-align: left;
  color: #fff;
`;
